module.exports = __webpack_public_path__ + "static/media/technician.fbf587b2.png";